import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import Button from "./common/Button";
import { EffectCards, Parallax } from "swiper";

import "swiper/css";
import "swiper/css/effect-cards";

import { SubscriptionButtton } from "../pages/subscription/subscriptionButton";
import useApiCalls from "../Hooks/useApiCalls";
import { subsapi } from "../Shared/helper";
import { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";


export default function MobileSliderMonthly() {
  const [subscriptionDetails, setSubscriptionDetails] = useState(null);
  const [activePlan, setActivePlan] = useState(null);
  const navigate = useNavigate();
  
  const api = useApiCalls();

  const fetchSubscriptionDetails = async () => {
    try {
      const res = await api(subsapi, 'get', {});
      setSubscriptionDetails(res.data);
      setActivePlan(res?.data?.data?.planId);
    } catch (error) {
      console.error('Error fetching subscription details:', error);
    }
  };
  
  useEffect(() => {
    fetchSubscriptionDetails();
  }, [activePlan]);

  const getDefaultPlan = async () => {
    try {
      const isConfirmed = window.confirm("Are you sure you want to cancel your subscription?");
      if (!isConfirmed) {
        return;
      }
      const res = await api(subsapi, 'delete', {});
      if(res.status === 200){
        navigate('/chat');
      }
    } catch (error) {
      console.error('Error in delete subscription:', error);
    }
  }

  return (
    <>
      <div className="plane-page mobile-slider">
        <Swiper
          effect={"cards"}
          loop={"true"}
          autoHeight={false} // This allows Swiper to adjust height dynamically

          grabCursor={true}
          modules={[EffectCards]}
          className="mySwiper"
        >
          <SwiperSlide>
            <div className="tab-col">
              <h3>Free</h3>
              <div className="sub-text">
                {" "}
                <sup>$</sup>0.00/Month{" "}
              </div>
              <p className="text-center m-text">Free Therapist</p>
              {activePlan ? (
                <button type='button' className="btn w-100" onClick={getDefaultPlan}>Get Default Plan</button>
              ) : (
                <Button title={"Default Plan"} className={"w-100"} />
              )}
             <ul>
                <li>
                  <span>
                    <img src="/assets/images/success.png" alt="" />
                  </span>
                  Limited messages
                </li>
                <li>
                  <span>
                    <img src="/assets/images/success.png" alt="" />
                  </span>
                  Available 24/7
                </li>
                <li>
                  <span>
                    <img src="/assets/images/success.png" alt="" />
                  </span>
                  Confidential Conversations
                </li>
              </ul>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="tab-col">
              <h3>Expert</h3>
              <div className="sub-text">
                {" "}
                <sup>$</sup>14.99/Month{" "}
              </div>
              <p className="text-center m-text">Billed Monthly</p>
                <div className="button-pay-wrap">
                <SubscriptionButtton 
                  activePlan={activePlan} 
                  setActivePlan={setActivePlan}
                  title="Expert Therapist" 
                  price="14.99" 
                  planId="P-3VL628773U860484SMXKOWNY" 
                  subscriptionDetails={subscriptionDetails}/>
                  </div>
                  <ul>
                <li>
                  <span>
                    <img src="/assets/images/success.png" alt="" />
                  </span>
                  Up to 30 Messages a Day
                </li>
                <li>
                  <span>
                    <img src="/assets/images/success.png" alt="" />
                  </span>
                  Available 24/7
                </li>
                <li>
                  <span>
                    <img src="/assets/images/success.png" alt="" />
                  </span>
                  Confidential Conversations
                </li>
                <li>
                  <span>
                    <img src="/assets/images/success.png" alt="" />
                  </span>
                  Retains Detailed Conversation History
                </li>
              </ul>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="tab-col">
              <h3>Unlimited</h3>
              <div className="sub-text">
                {" "}
                <sup>$</sup>19.99/Month{" "}
              </div>
              <p className="text-center m-text">Billed Monthly</p>
              <div className="button-pay-wrap">
                <SubscriptionButtton 
                  activePlan={activePlan} 
                  setActivePlan={setActivePlan}
                  title="Expert Unlimited" 
                  price="19.99" 
                  planId="P-5BW13521V02354646MXKOXJA"
                  subscriptionDetails={subscriptionDetails} />
                </div>
                <ul>
                <li>
                  <span>
                    <img src="/assets/images/success.png" alt="" />
                  </span>
                  Unlimited Messages
                </li>
                <li>
                  <span>
                    <img src="/assets/images/success.png" alt="" />
                  </span>
                  Available 24/7
                </li>
                <li>
                  <span>
                    <img src="/assets/images/success.png" alt="" />
                  </span>
                  Confidential Conversations
                </li>
                <li>
                  <span>
                    <img src="/assets/images/success.png" alt="" />
                  </span>
                  Retains Detailed Conversation History
                </li>
              </ul>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="tab-col">
              <h3>Premium</h3>
              <div className="sub-text">
                {" "}
                <sup>$</sup>29.99/Month{" "}
              </div>
              <p className="text-center m-text">Billed Monthly</p>
              <div className="button-pay-wrap">
                <SubscriptionButtton 
                  activePlan={activePlan} 
                  setActivePlan={setActivePlan}
                  title="Premium" 
                  price="29.99" 
                  planId="P-42N13264CH6025134M3X6RSY"
                  subscriptionDetails={subscriptionDetails} />
                </div>
                <ul>
                <li>
                  <span>
                    <img src="/assets/images/success.png" alt="" />
                  </span>
                  Unlimited Messages
                </li>
                <li>
                  <span>
                    <img src="/assets/images/success.png" alt="" />
                  </span>
                  Available 24/7
                </li>
                <li>
                  <span>
                    <img src="/assets/images/success.png" alt="" />
                  </span>
                  Confidential Conversations
                </li>
                <li>
                  <span>
                    <img src="/assets/images/success.png" alt="" />
                  </span>
                  AI model with unique fine-tuning
                </li>
                <li>
                  <span>
                    <img src="/assets/images/success.png" alt="" />
                  </span>
                  Frequent updates and improvements
                </li>
              </ul>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </>
  );
}
